/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_SuggestionsInputs */

const en_search_suggestions = /** @type {(inputs: Search_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search suggestions`)
};

const nl_search_suggestions = /** @type {(inputs: Search_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeksuggesties`)
};

/**
* | output |
* | --- |
* | "Search suggestions" |
*
* @param {Search_SuggestionsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const search_suggestions = /** @type {((inputs?: Search_SuggestionsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_SuggestionsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_search_suggestions(inputs)
	return en_search_suggestions(inputs)
});